<template>
  <div>
    <div v-if="step == 0">
      <app-step0 :categories="categories" @click="nextStep" />
    </div>
    <div v-else-if="step == 1">
      <app-maharat v-if="isMaharat" :info="history.info" :keys="history.keys" :category="selectedCategory"
        @saveMaharat="saveMaharat" @removeMaharat="removeMaharatHandler" />
      <app-step1 v-else :history="history" :category="selectedCategory" :editable="selectedEditable" @click="nextStep"
        @removeRecord="removeRecord" />
    </div>

    <div v-else-if="step == 2">
      <app-step2 :columns="history.columns" :keys="history.keys" :record="selectedRecord" :category="selectedCategory"
        @removeAttach="removeAttach" @applyRequest="saveRecord" />
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Step0 from "./Categories";
import Step1 from "./History";
import Step2 from "./Request";
import Maharat from "./Maharat";
import Dialog from "@/components/Dialog";
import {
  getCategories,
  getHistory,
  removeAttach,
  removeRecord,
  saveRecord,
} from "@/api/resume";
import { getAllData, saveMaharat, removeMaharat } from "@/api/maharat";
export default {
  data() {
    return {
      step: 0,

      categories: [],
      history: {},
      selectedCategory: "",
      selectedTitle: "",

      selectedEditable: false,
      isMaharat: false,
      selectedIndex: null,
      removeType: "",
    };
  },
  computed: {
    selectedRecord() {
      if (this.selectedIndex != null) {
        return this.history.data[this.selectedIndex];
      } else {
        return this.history.template;
      }
    },
  },
  components: {
    appStep0: Step0,
    appStep1: Step1,
    appMaharat: Maharat,
    appStep2: Step2,
    appDialog: Dialog,
  },
  methods: {
    nextStep(param) {
      switch (this.step) {
        case 0:
          this.selectedCategory = param.Name;
          this.selectedTitle = param.Title;
          this.selectedEditable = param.Editable;

          this.isMaharat = param.IsMaharat;


          if (this.isMaharat) {
            this.getMaharatData();
          } else {
            this.getCategoryHistory();
          }

          break;
        case 1:
          this.selectedIndex = param;

          break;
      }

      this.$router.push({
        query: {

          step: ++this.step
        }
      });

    },
    getMaharatData() {
      getAllData(this.selectedCategory)
        .then((response) => {
          const data = response.data;
          this.history = data;
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    getCategoryHistory() {
      getHistory(this.selectedCategory)
        .then((response) => {
          const data = response.data;
          this.history = data;
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    removeAttach(index) {
      this.removeType = "attach";
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این پیوست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    removeRecord(index) {
      this.removeType = "record";
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این سابقه هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    removeMaharatHandler(index) {
      removeMaharat(index)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

          if (data.Success) {
            this.getMaharatData();
          }
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        if (this.removeType == "attach") {
          removeAttach(this.selectedCategory, index)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

              if (data.Success) {
                this.getCategoryHistory();
              }
            })

            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        } else if (this.removeType == "record") {
          removeRecord(this.selectedCategory, index)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

              if (data.Success) {
                this.getCategoryHistory();
              }
            })

            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        }
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    saveRecord(file, record) {
      this.$store.commit("SET_API_RUNNING", true);
      saveRecord(file, record, this.selectedCategory)
        .then((response) => {
          const data = response.data;

          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          this.$store.commit("SET_API_RUNNING", false);
          if (data.Success) {
            this.$router.push({
              query: {

                step: 1
              }
            });
            this.getCategoryHistory();
          }
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    saveMaharat(info) {
      saveMaharat(info)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

          if (data.Success) {
            this.getMaharatData();
          }
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    GetCategories() {
      getCategories()
        .then((response) => {
          const data = response.data;
          this.categories = data;
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    }
  },

  created() {
    if (this.$route.query.step) {
      this.$router.replace({
        query: {}
      })
    }
    this.GetCategories()
  },
  watch: {

    '$route'(to, from) {
      this.step = this.$route.query.step ? Number(this.$route.query.step) : 0;
    }
  },
};
</script>
